import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

export interface MetricCardConfig {
  label: string;
  value: number | string;
  icon: React.ReactNode;
  color: string;
  bgLight: string;
}

interface MetricSummaryProps {
  cards: MetricCardConfig[];
}

export const MetricCard = ({cards}: MetricSummaryProps) => {
  const tamTarjetas = cards.length === 3 
        ? 4 : 
          cards.length >= 4 ? 3
            : 6
  return(
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={tamTarjetas} key={card.label}>
          <Card
            sx={{
              height: '100%',
              position: 'relative',
              overflow: 'hidden',

              borderLeft: `4px solid ${card.color}`,
              bgcolor: 'background.paper',

              // transition: 'transform 0.2s, box-shadow 0.2s',
              // Animación fluida
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              background: `linear-gradient(135deg, #ffffff 0%, #ffffff 100%)`,

              '&:hover': {
                // transform: 'translateY(-3px)',
                // boxShadow: 4,
                transform: 'translateY(-6px)',
                boxShadow: `0 14px 28px -10px ${card.color}80, 0 10px 10px -10px ${card.color}40`,
                background: `linear-gradient(135deg, #ffffff 70%, ${card.bgLight} 100%)`,
              },
            }}
          >
            <CardContent sx={{ py: 2, px: 2.5, '&:last-child': { pb: 2 } }}>
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 48,
                    height: 48,
                    borderRadius: '12px',
                    bgcolor: card.bgLight,
                    color: card.color,

                    transition: 'all 0.3s ease',
                    '.MuiCard-root:hover &':{
                      transform: 'scale(1.1) rotate(3deg)',
                      boxShadow: `0 4px 10px ${card.color}40`
                    }
                  }}
                >
                  {card.icon}
                </Box>
                <Box flex={1}>
                  <Typography variant="h4" fontWeight="bold" lineHeight={1.2}
                    sx={{
                      transition: 'color 0.3s ease',
                      '.MuiCard-root:hover &': {
                        color: card.color,
                      }
                    }}
                  >
                    {card.value}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" fontWeight={500}>
                    {card.label}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}